import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';
import { ModalController } from '@ionic/angular';
import { UpsertSheetOptions, SectionData, SelectedValues, SelectorValue } from './upsert-sheet.model';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { EventModel } from '@boxx/events-core/lib/models/events.model';
import { format, parseISO } from 'date-fns';
import * as moment from 'moment';
import { STATES_DATA } from 'src/assets/statesData';
import Swiper from 'swiper';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { APP_CONSTANTS } from 'src/constants/constants';

@Component({
  selector: 'app-upsert-sheet',
  templateUrl: './upsert-sheet.component.html',
  styleUrls: ['./upsert-sheet.component.scss']
})
export class UpsertSheetComponent implements OnInit {

  @Input() config: UpsertSheetOptions;
  selectedValue: string | SelectedValues;
  filteredData: any = [];
  QRMessage: string;

  form: FormGroup = new FormGroup({
    quantity: new FormControl(6, [Validators.required, Validators.min(0)])
  });
  labelMinMax: string;
  websiteUrlString: string;
  translations: any;
  destroyed$ = new Subject<boolean>();
  isCordovaOrCapacitor = false;
  event: EventModel;

  customMinutes = [10, 15, 20, 30, 45, 60, 90, 120];

  types = STATES_DATA;

  langList = [
    {
      key: 'es',
      name: 'Español - Spanish',
      icon: './assets/country-flags/svg/mx.svg'
    },
    {
      key: 'en',
      name: 'Inglés - English',
      icon: './assets/country-flags/svg/us.svg'
    }
  ];

  @ViewChild('swipperSlider')
  swiperRef: ElementRef | undefined;
  swiper?: Swiper;

  currentIndex = 0;


  public maxDate = (Number(new Date().getFullYear()) + 1) + '-12-31';
  public customDate: any;
  public currentTime: any;

  public defaultDate: any;
  public defaultTime: any;

  public localeString: string;
  public customPres: string = '';
  public paramPres: string;
  public currentDate: string;
  userEmail: string = '';
  orderForm: FormGroup;

  // theme: ThemeEnum = ThemeEnum.omni;
  constructor(
    private modalCtrl: ModalController,
    private translate: TranslateService,
    private socialSharing: SocialSharing,
    private fb: FormBuilder
  ) {
    this.translate
      .get(['QR', 'CLIPBOARD', 'PANEL_VIEW', 'EVENTS_MODULE', 'ACTIONS'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((t: any) => (this.translations = t));
  }

  async ngOnInit() {
    if (this.config.type !== 'historyDetail' && this.config.type !== 'addEmail'  && this.config.type !== 'confirmOrder' 
      && this.config.type !== 'deleteCategory' && this.config.type !== 'deleteCoupon' && this.config.type !== 'deleteSubcategory' && this.config.type !== 'deleteProduct'
    ) {
      this.filteredData = [...this.config.data];

      this.currentDate = moment().add(1, 'days').format("YYYY-MM-DD");
      const splitTime = this.currentDate.toString().split('T');
      this.defaultTime = splitTime[1].slice(0, 5);
    }

    this.orderForm = this.fb.group({
      email: ['', [Validators.required, Validators.pattern(APP_CONSTANTS.EMAILPATTERN)]],
    });
  }

  ionViewDidEnter() {
    if (this.config?.currentValue) {
    }
  }

  setPicker(_type: number) {
    if (_type === 1) {
      this.customPres = 'date';
    }
    else {
      this.customPres = 'time';
    }
  }

  validateSiteQR() {
    if (!this.config?.firstTimeOpen) {
      if (this.config?.site.type === 'agency_website' || this.config?.site.type === 'website') {
        this.QRMessage = this.translations.PANEL_VIEW.WIDGET.QR.alternativeTitle;
      }
      else if (this.config?.site.type === 'shop') {
        this.QRMessage = this.translations.PANEL_VIEW.WIDGET.QR.alternativeTitleStore;
      }
      else if (this.config?.site.type === 'directory') {
        this.QRMessage = this.translations.PANEL_VIEW.WIDGET.QR.alternativeTitleDirectory;
      }
    }
    else {
      setTimeout(async () => {
        if (this.config?.site.type === 'agency_website' || this.config?.site.type === 'website') {
          this.QRMessage = this.translations.PANEL_VIEW.WIDGET.QR.alternativeTitle;
        }
        else if (this.config?.site.type === 'shop') {
          this.QRMessage = this.translations.PANEL_VIEW.WIDGET.QR.alternativeTitleStore;
        }
        else if (this.config?.site.type === 'directory') {
          this.QRMessage = this.translations.PANEL_VIEW.WIDGET.QR.alternativeTitleDirectory;
        }
      }, 100);
    }
    this.websiteUrlString = this.config?.site.url;
    console.log('this.websiteUrlString: ', this.websiteUrlString);
  }

  onSelect() {
    this.modalCtrl.dismiss({ value: this.selectedValue });
  }

  onItemSelect(itemValue) {
    this.modalCtrl.dismiss({ value: itemValue });
  }

  onSiteSelect(itemValue, url) {
    this.modalCtrl.dismiss({ value: itemValue, url });
  }

  onValueChange() {
    this.modalCtrl.getTop().then(modal => {
      if (this.selectedValue || this.selectedValue?.length > 0) {
        modal.setCurrentBreakpoint(1);
      } else {
        modal.setCurrentBreakpoint(this.config.initialBreakpoint);
      }
    })
  }
  fullOpen() {
    this.modalCtrl.getTop().then(modal => {
      modal.setCurrentBreakpoint(1);
    });
  }

  onCancelAction() {
    this.selectedValue = null;
    this.modalCtrl.dismiss({ value: { isCancel: true } });
  }

  itemSelected(item: SelectorValue, sectionKey: string) {
    const existingValue = (this.selectedValue as SelectedValues).find(value => value.sectionKey === sectionKey);
    if (existingValue) {
      const existingIndex = (this.selectedValue as SelectedValues).findIndex(value => value.sectionKey === sectionKey);
      (this.selectedValue as SelectedValues)[existingIndex] = { sectionKey, item };
    } else {
      (this.selectedValue as SelectedValues).push({ sectionKey, item });
    }
    this.onValueChange();
  }

  getAccordionGroupValues() {
    let listSectionKeys: string[] = [];
    if (this.selectedValue?.length > 0) {
      (this.selectedValue as SelectedValues).forEach(currentValue => {
        const data = this.config.data as SectionData[];
        const fetchData = data.find(value => value.section.key === currentValue?.sectionKey);
        listSectionKeys.push(`${fetchData.section.key}`);
      });
    }
    return listSectionKeys;
  }

  getRadioValue(sectionData: SectionData) {
    if (this.selectedValue?.length > 0) {
      const sectionExist = (this.selectedValue as SelectedValues).find(value => value.sectionKey === sectionData.section.key);
      if (sectionExist) {
        return sectionData.items.find(item => item.key === sectionExist.item.key);
      }
    }
  }

  onSearchChange(e) {
    let value: string = e.detail.value;
    if (!value?.length) {
      this.filteredData = [...this.config.data];
      return;
    }
    value = value.toLocaleLowerCase();
    this.filteredData = [...this.config.data].filter((x: any) => {
      if (typeof x === 'string') {
        return x.toLocaleLowerCase().includes(value);
      }
      // !Caution, if translation is passed as value only search by key will work
      if (
        x.key.toLocaleLowerCase().includes(value) ||
        x.value.toLocaleLowerCase().includes(value)
      ) {
        return true;
      }
      return false;
    })
  }

  closeKeyboard() {
    if (Capacitor.isNativePlatform()) {
      Keyboard.hide().catch(console.warn);
    }
  }

  getIconOpt(iconName: string) {
    return `assets/icon/${iconName}.svg`;
  }

  closeActionSheet() {
    this.modalCtrl.dismiss();
  }

  dateFormat(date: string) {
    if (date && date !== null && date !== undefined) {
      return format(parseISO(moment(date).format()), 'dd MMM yyyy - HH:mm');
    }
  }

  selectState(state: any) {
    this.modalCtrl.dismiss({ value: state });
  }

  selectLanguage(lng: any) {
    this.modalCtrl.dismiss({ value: lng });
  }

  swiperReady() {
    this.swiper = this.swiperRef?.nativeElement.swiper;
  }

  swiperSlideChanged(e: any) { }

  async shareUrl(url: string, url_type: string) {
    const platform = Capacitor.getPlatform();
    let _title = '';
    switch (url_type) {
      case 'agency_website':
      case 'website':
      case 'directory':
        _title = this.translations.ACTIONS.shareSite;
        break;
      case 'shop':
        _title = this.translations.ACTIONS.shareStore;
        break;

      default:
        break;
    }
    console.log('_title: ', _title)
    if (platform === 'android' || platform === 'ios') {
      try {
        this.socialSharing.share(_title, _title, null, url)
          .then(() => { }).catch((error) => { });

        // await Share.share({
        //   title: _title,
        //   text: url,
        //   dialogTitle: _title,
        // });
      } catch (error) { }
      return;
    }
  }

  close() {
    this.modalCtrl.dismiss();
  }

  accept() {
    if (this.config.type === 'addEmail') {
      let _formData = this.orderForm.value;
      this.modalCtrl.dismiss({ value: _formData.email });
    }
    if (this.config.type === 'confirmOrder' || this.config.type === 'deleteCategory' || this.config.type === 'deleteCoupon' || this.config.type === 'deleteSubcategory' || this.config.type === 'deleteProduct') {
      this.modalCtrl.dismiss({ value: true });
    }
  }
}
